<template>
    <page-placeholder v-if="project.isLoaded">
        <v-row>
            <v-col :cols="12">
                <website-pages-positioned-count-evolution/>
            </v-col>

            <v-col :cols="12">
                <website-pages-best-positioned-pages/>
            </v-col>
        </v-row>
    </page-placeholder>

</template>


<script>
import PagePlaceholder from "@/components/yooda-components/PagePlaceholder";

import WebsitePagesPositionedCountEvolution from "@/components/yooda-components/app/website-pages/WebsitePagesPositionedCountEvolution";
import WebsitePagesBestPositionedPages from "@/components/yooda-components/app/website-pages/WebsitePagesBestPositionedPages";

export default {
    components: {
        PagePlaceholder,
        WebsitePagesPositionedCountEvolution,
        WebsitePagesBestPositionedPages
    },
}

</script>
